/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Table_TermInputs */

const en_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Term`)
};

const fr_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terme`)
};

const de_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begriff`)
};

const it_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

const ru_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок`)
};

const es_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Término`)
};

const zh_cn2_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学期`)
};

const ja_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学期`)
};

const hi_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_tags_manager_table_term = /** @type {(inputs: Tags_Manager_Table_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo`)
};

/**
* | output |
* | --- |
* | "Term" |
*
* @param {Tags_Manager_Table_TermInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_table_term = /** @type {((inputs?: Tags_Manager_Table_TermInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Table_TermInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_table_term(inputs)
	if (locale === "de") return de_tags_manager_table_term(inputs)
	if (locale === "it") return it_tags_manager_table_term(inputs)
	if (locale === "ru") return ru_tags_manager_table_term(inputs)
	if (locale === "es") return es_tags_manager_table_term(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_table_term(inputs)
	if (locale === "ja") return ja_tags_manager_table_term(inputs)
	if (locale === "hi") return hi_tags_manager_table_term(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_table_term(inputs)
	return en_tags_manager_table_term(inputs)
});